var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-modal',{attrs:{"centered":true,"dialog-style":{ margin: '0px', width: '100px !important' },"title":"Remove User"},on:{"ok":function () { return (_vm.showModal = false); }},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('template',{slot:"footer"},[_c('button',{key:"cancel",style:({
          background: '#fff',
          color: _vm.getPrimaryColor(),
          padding: '10px 40px',
          'border-radius': '8px',
          border: '1px solid ' + _vm.getPrimaryColor(),
        }),on:{"click":function($event){_vm.showModal = false}}},[_vm._v("\n        Cancel\n      ")]),_vm._v(" "),_c('a-button',{key:"submit",staticClass:"primary-button",style:({
          border: '1px solid ' + _vm.getPrimaryColor(),
          background: _vm.getPrimaryColor(),
          padding: '10px 40px',
          'border-radius': '8px'
        }),attrs:{"type":"primary"},on:{"click":function($event){return _vm.removeUserFromCircle()}}},[_vm._v("\n        Remove\n      ")])],1),_vm._v(" "),(_vm.user)?_c('p',{style:({
        'font-size': '16px'
      })},[_vm._v("\n      Do you want to remove "+_vm._s(_vm.user.display_name)+" ?\n    ")]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a6dcb52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/RemoveUser.vue
// module id = null
// module chunks = 